export default __webpack_public_path__ + "static/media/snow-3-night.07c3824d.svg";